import PropTypes from 'prop-types';
import React from 'react';
import PushNotificationPreview from '../containers/PushNotificationPreview';
import EmailPreview from '../containers/EmailPreview';
import CampaignVerbiage from '../containers/CampaignVerbiage';

const ViewCampaign = ({
  showPushPreview,
  startDate,
  endDate,
  frequency,
  time,
  isLoading,
  isRecurring,
  isCampaignPaused,
}) => (
  <div className="extra-extralarge-and-up-ph extralarge-and-up-pv u-p+">
    <div className="layout layout--huge">
      <div className="layout__item u-3/5-extralarge-and-up u-1/2-extra-extralarge-and-up">
        <div className="layout layout--rev">
          <div className="layout__item u-1/3-medium-and-up">
            <PushNotificationPreview display-if={showPushPreview} />
          </div>
          <div className="layout__item u-2/3-medium-and-up">
            <EmailPreview editable={false} />
          </div>
          {!isLoading && isRecurring && !isCampaignPaused && (
            <div>
              <CampaignVerbiage startDate={startDate} endDate={endDate} frequency={frequency} time={time} />
            </div>
          )}
        </div>
      </div>
    </div>
  </div>
);

ViewCampaign.propTypes = {
  showPushPreview: PropTypes.bool.isRequired,
  startDate: PropTypes.string.isRequired,
  frequency: PropTypes.number.isRequired,
  time: PropTypes.string.isRequired,
  endDate: PropTypes.string,
  isLoading: PropTypes.bool.isRequired,
  isRecurring: PropTypes.bool,
  isCampaignPaused: PropTypes.bool,
};

ViewCampaign.defaultProps = {
  endDate: null,
  isRecurring: false,
  isCampaignPaused: false,
};

export default ViewCampaign;
